import React from 'react';

import { getReport, IReport } from '~/src/dash/api/console-api';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { LoadingView } from '~/src/dash/views/loading-view';
import { SSPReportFormView } from '~/src/dash/views/ssp-report-form-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  report?: IReport;
}

export const SSPReportExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      report: undefined,
    };

    componentDidMount() {
      const loc = parseLocation(this.props.location.pathname);
      getReport({
        query: {
          publisher_id: this.props.session.publisher.ID,
          report_id: loc.report,
        },
      }).then((report: IReport) => {
        this.setState({
          report,
        });
      });
    }

    render() {
      return (
        <div>
          {this.state.report ? (
            <SSPReportFormView report={this.state.report} />
          ) : (
            <LoadingView active={true} text='Loading the report settings' />
          )}
        </div>
      );
    }
  },
);
